import { css } from 'styled-components';
import { keys, reduce } from 'lodash/fp';

const sizes = {
  xs: 0,
  sm: 600,
  md: 1024,
  lg: 1334,
  xl: 1600,
};

const resolutions = {
  oneX: 1,
  twoX: 2,
  threeX: 3,
};

const media = {
  ...reduce((acc, label) => ({
    ...acc,
    [label]: (...args) => css`
      @media (min-width: ${sizes[label]}px) {
        ${css(...args)}
      }
    `,
  }), {}, keys(sizes)),
  ...reduce((acc, label) => ({
    ...acc,
    [label]: (...args) => css`
      @media
        (-webkit-min-device-pixel-ratio: ${resolutions[label]}),
        (min-resolution: ${resolutions[label]}dppx),
        (min-resolution: ${resolutions[label] * 96}dpi) {
          ${css(...args)}
        }
    `,
  }), {}, keys(resolutions)),
};

export default media;
